import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgFilterIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 10"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="current"
      d="M7.058 10a.49.49 0 0 1-.5-.501q0-.213.144-.356A.49.49 0 0 1 7.058 9h1.865q.213 0 .356.144a.5.5 0 0 1 .144.357q0 .213-.144.356a.49.49 0 0 1-.356.143zm-3.75-4.5a.49.49 0 0 1-.5-.501q0-.213.144-.356a.49.49 0 0 1 .356-.143h9.365q.213 0 .356.144a.5.5 0 0 1 .144.357q0 .213-.144.356a.49.49 0 0 1-.356.143zM.5 1A.49.49 0 0 1 0 .499Q0 .286.144.143A.49.49 0 0 1 .5 0h15q.213 0 .356.144A.5.5 0 0 1 16 .501q0 .213-.144.356A.49.49 0 0 1 15.5 1z"
    />
  </svg>
)
export default SvgFilterIcon
